var React = require('react');

function Bg (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#496e2d","d":"M0 166.9l258-31.7 254 31.7v178l-251.4 41.3L0 344.9z","key":0}),React.createElement("path",{"fill":"#eee","d":"M0 0h512v166.9H0z","key":1}),React.createElement("path",{"fill":"#d80027","d":"M0 344.9h512V512H0z","key":2})])]);
}

Bg.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Bg;

Bg.default = Bg;
